import { ValidationConstants } from './validation-constants';

export type descriptionPositionType = 'left' | 'right' | 'bottom' | 'top';
export type labelPositionType = 'left' | 'right';
export type popupPositionType = 'top' | 'right' | 'bottom' | 'left';
export const descriptionPositionValues = {
    top: 'top' as descriptionPositionType,
    bottom: 'bottom' as descriptionPositionType,
    left: 'left' as descriptionPositionType,
    right: 'right' as descriptionPositionType
};
export const timeFormatMonitoring = 'M/DD/YYYY, LTS';
export const timeFormatWithSeconds = 'M/D/YY, LTS';
export const timeFormatWithoutSeconds = 'M/D/YY LT';
export class Constants {
    // regex
    public static alphaNumericUnderscoreValidation: RegExp = /^[_A-Za-z0-9]+$/;
    public static alphaNumericUnderscoreSpaceValidation: RegExp = /^[_A-Za-z0-9 ]+$/;
    public static alphaNumericWithAlphaInitialValidation: RegExp = /^[A-Za-z][A-Za-z0-9]*$/;
    public static dataFlowEscapedNameValidation: RegExp = /^\{.*\}$/;
    public static dataFlowDataTypeSpecialCharValidation: RegExp = /[\'\"]/;
    public static noDash: RegExp = /^[^-]*$/;
    public static noSpace: RegExp = /^[^\s]*$/;
    public static noQuestionMark: RegExp = /^[^\?]*$/;
    public static notBeginWithNumber: RegExp = /^[^0-9]/;
    public static arrayIndexRegex: RegExp = /\[\d+\]$/;
    public static factoryEntityNameValidator: RegExp = ValidationConstants.factoryEntityNameValidator;
    public static artifactNameValidator: RegExp = ValidationConstants.factoryEntityNameValidator;
    public static entityInDatabaseNameValidator: RegExp = /^([_A-Za-z0-9]|([_A-Za-z0-9][\s-_A-Za-z0-9]{0,138}[_A-Za-z0-9]))\$\$([_A-Za-z0-9]|([_A-Za-z0-9][\s-_A-Za-z0-9]{0,138}[_A-Za-z0-9]))$/;
    public static dataFactoryNameValidation: RegExp = /^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*$/;
    public static resourceGroupNameValidation: RegExp = /^[A-Za-z0-9_\-().]*[A-Za-z0-9_\-()]$/;
    public static nameValidationNoDash: RegExp = /^[A-Za-z0-9]+[_A-Za-z0-9]*[_A-Za-z0-9]$/;
    public static repoNameValidation: RegExp = /^[-()A-Za-z0-9\^!][-_()A-Za-z0-9\^!]*(?:[\.\s]+[-_()A-Za-z0-9\^!]+)*$/;
    public static folderNameStricterValidation: RegExp = /^[^":<>\\*?|]+$/;
    public static folderNameValidation: RegExp = /^[^":<>\\|]+$/;
    public static folderNameValidation2: RegExp = /^.*[^.]$/;
    public static branchNameValidation: RegExp = /^[-(){}A-Za-z0-9!][-_(){}A-Za-z0-9!]*(?:[\./]+[-_(){}A-Za-z0-9!]+)*$/;
    public static timeoutValidation: RegExp = /^((\d+)\.)?(\d\d):(60|([0-5][0-9])):(60|([0-5][0-9]))$/;
    public static storageScopeValidation: RegExp = /^\/subscriptions\/[a-zA-Z0-9-]+\/resourceGroups\/[-\w\._\(\)À-ÿ]+\/providers\/Microsoft\.Storage\/storageAccounts\/[a-z0-9]{3,24}$/;
    public static containerNameValidation: RegExp = /^\/((\$All_Containers\$)|([a-z0-9](?:[a-z0-9]|-(?!-)){1,61}[a-z0-9]))\/$/;
    public static startsWithValidationDataPreview: RegExp = /^[^\/](.{1,1024})?$/;
    public static startsWithValidation: RegExp = /^(?:\/blobServices\/default\/containers)?\/([a-z0-9](?:[a-z0-9]|-(?!-)){1,61}[a-z0-9])\/(?:blobs\/|blobs\/(.{1,1024})?)?$/;
    public static endsWithValidation: RegExp = /^(?:\/blobs\/|(?:\/blobServices\/default\/containers)?\/([a-z0-9](?:[a-z0-9]|-(?!-)){1,61}[a-z0-9])\/blobs\/)?(.{0,1023}[^\/])$/;
    public static writeTimeoutValidation: RegExp = /^(\d+\.)?((0?\d)|(1\d)|(2[0-3]))(:[0-5]?\d){2}$/;
    public static dataFlowColumnNameValidation: RegExp = /^[^ ,;{}()\n\t=]+$/;
    // must be at least one character long, without '/' or '\', no trailing dot, and no leading or trailing spaces
    public static lakehouseTableNameValidation: RegExp = /^(?!.*[\\/])(?=\S)(?!.*\s$)(?!.*\.$)[^\s][^\\]*(?<!\.)$/;
    public static lakehouseSchemaValidation: RegExp = /^[_A-Za-z0-9]*$/;
    public static blobContainerNameValidation: RegExp = /^([a-z0-9\$](?:[a-z0-9]|(\-(?!\-))){1,61}[a-z0-9])(\/.*)*$/;
    public static fileSharePathValidation: RegExp = /^(?:[^\\/:*?"<>|\r\n]+\/)*[^\\/:*?"<>|\r\n]*$/;
    public static numericValidation: RegExp = /^[1-9]\d*|0$/;
    public static slashSpaceValidation: RegExp = /^[^ /]+$/;
    // eslint-disable-next-line max-len
    public static alertEmailValidation: RegExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    public static alertPhoneValidation: RegExp = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
    public static alertPhoneValidationChina: RegExp = /^\(?(13[0-9]|145|147|15[0-3,5-9]|16[2,5-7]|17[0-3,5-8]|18[0-9])\)?[- ]?(\d{4})[- ]?(\d{4})$/;
    public static guidValidation: RegExp = /^[0-9A-Fa-f]{8}-([0-9A-Fa-f]{4}-){3}[0-9A-Fa-f]{12}$/;
    public static unicodeAndSingleCharRegex: RegExp = /^(\\u([0-9a-f]){4}|[^])$/;
    public static urlRegex: RegExp = /(https?:\/\/[-a-zA-Z0-9:%_\+.~#?&//=]+)/;
    public static azureDataShareAccountNameValidation: RegExp = /[^<>%&:\\?/#*$^();,.|\-+={}[\]!~@]{3,90}/;
    public static subscriptionIdValidation: RegExp = /[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}/;
    public static keyVaultKeyUrlValidator: RegExp = new RegExp(/^(https:\/\/.+)\/keys\/([\w-]+)(\/(\w+))?$/);
    public static systemManagedIdentityValidation: RegExp = /^(?!(FactorySystemIdentity|WorkspaceSystemIdentity)$).*$/i;
    public static snowflakeApiVersionValidation: RegExp = /(^\d+\.\d$)|(^Default$)/;
    public static gitDevopsLinkValidation: RegExp = /https:\/\/.+(visualstudio|azure).+(_git)\/\w/;
    public static wildcardsValidation: RegExp = /^[^\+\*]+$/;
    // eslint-disable-next-line max-len
    public static storageValidEndpointSuffixes = 'core\\.windows\\.net|core\\.usgovcloudapi\\.net|core\\.chinacloudapi\\.cn|core\\.eaglex\\.ic\\.gov|core\\.microsoft\\.scloud|core\\.sovcloud-api\\.fr|core\\.sovcloud-api\\.de|core\\.sovcloud-api\\.sg';
    public static partitionedDnsEndpointSuffix = 'storage\\.azure\\.net';
    // eslint-disable-next-line max-len
    public static blobContainerUriPattern = `^https://[^\/\.]+(?:\\.blob\\.(?:${Constants.storageValidEndpointSuffixes})|\\.z[0-9]+\\.blob\\.${Constants.partitionedDnsEndpointSuffix})/([a-z0-9\$](?:[a-z0-9]|(?:\-(?!\-))){1,61}[a-z0-9])/?$|^[*]{10}$`;
    // eslint-disable-next-line max-len
    public static blobSasUriPattern = `^https://[^\/\.]+(?:\\.blob\\.(?:${Constants.storageValidEndpointSuffixes})|\\.z[0-9]+\\.blob\\.${Constants.partitionedDnsEndpointSuffix})/([a-z0-9\$](?:[a-z0-9]|(?:\-(?!\-))){1,61}[a-z0-9])/?.*$|^[*]{10}$`;

    public static generalConnectionUriPattern = `^(?:https?|adl)://(?:[^/]+)/(.*)$`;

    // numbers
    public static applicatonErrorStatus: number = -1;
    public static maxEntityNameLength: number = 140;
    public static maxResourceGroupNameLength: number = 80;
    public static minDataFactoryNameLength: number = 3;
    public static maxDataFactoryNameLength: number = 63;

    // strings
    public static timeoutValidationPattern = '^(\\d+\\.)?((0?\\d)|(1\\d)|(2[0-3]))(:[0-5]?\\d){2}$';
    public static sapCdcSubscriberNameAndProcessPattern: RegExp = /^[a-zA-Z0-9+.$\-_]*$/;
    public static readonly maskedCredential: string = '**********'; // Do not modify this value since ADMS backend relis on it.

    public static utcTimeValidation: RegExp = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d+Z$/;
}

export type LoadingState = 'initial' | 'loading' | 'loaded' | 'error';

export enum EntityScope {
    ADF = 'ADF',
    Synapse = 'Synapse',
    SynapseLite = 'SynapseLite',
    Trident = 'PBI'
}
